// MSAL Instance Factory
// Creates the MSAL instance lazily after runtime config is loaded
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { localConfig } from "../config/localConfig";

let instance = null;

export const getMsalInstance = () => {
  if (!instance && !localConfig.skipAuth) {
    instance = new PublicClientApplication(msalConfig);
  }
  return instance;
};
